import React from 'react'
import { v4 as uuidv4 } from 'uuid'

import './colorSwitch.scss'

const ColorSwitch = ({ value, ...props }) => {
	const id = uuidv4()

	return (
		<div className={`o-color-switch o-color-switch--${value}`}>
			<input
				className="o-color-switch__input"
				type="radio"
				value={value}
				id={id}
				{...props}
			/>
			<label htmlFor={id} className="o-color-switch__label" />
		</div>
	)
}

export default ColorSwitch
